export interface SignatureData {
    id: number;
    tenant_owner: boolean;
    name: string;
    email: string;
    status: string;
    phone?: null;
    profile_image?: null;
    signature: string;
    login_via: string;
    workspaces_ordered_by_default?: (WorkspacesOrderedByDefaultEntity)[] | null;
}
export interface WorkspacesOrderedByDefaultEntity {
    id: number;
    name: string;
    is_organization: boolean;
    organization?: null;
    registration_number?: null;
    phone?: null;
    address?: null;
    zipcode?: null;
    city?: null;
}

export interface GenerateSignature {
    status: 'done' | 'failed'
    signature: SignatureData
}

export enum SignatureType {
    MYSIGNATURE = 'my_signature',
    DRAW = 'draw',
    TYPE = 'type',
    UPLOAD = 'upload',
    SMARTPHONE = 'smartphone'
}